import { render, staticRenderFns } from "./MiniAppRuiDiTuiActivity.vue?vue&type=template&id=db91650c&scoped=true&"
import script from "./MiniAppRuiDiTuiActivity.vue?vue&type=script&lang=js&"
export * from "./MiniAppRuiDiTuiActivity.vue?vue&type=script&lang=js&"
import style0 from "./MiniAppRuiDiTuiActivity.vue?vue&type=style&index=0&id=db91650c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db91650c",
  null
  
)

export default component.exports